/* eslint-disable react/require-default-props */
import React from "react";

import { ThemeProvider } from "styled-components";
import { theme } from "theme";
import { isHostLaunchedMicrosite } from "utils";
import { MICROSITES } from "utils/constants";

interface ThemedLayoutProps {
	availableVendor?: string;
}

const NewThemedLayout: React.FC<ThemedLayoutProps> = ({ children, availableVendor }) => {
	const vendor = availableVendor || isHostLaunchedMicrosite();

	return (
		<ThemeProvider theme={vendor === MICROSITES.VI ? theme.vi : theme.apna}>
			<div>{children}</div>
		</ThemeProvider>
	);
};

export default NewThemedLayout;
